import axios from 'axios';

export interface SinglePayment {
  id: number;
  amount: number;
  status: string | number;
  user: User;
  currency: Currency;
  chosen_supplier?: string | null;
  quote_number?: number | null;
  num_quotes?: number | null;
  generation?: {
    id: number;
    description: string;
    career_id?: number;
  };
}
interface User {
  id: number;
  email: string;
  name?: string;
  firstname?: string;
  lastname: string;
  phone: string;
}
type Currency = {
  id: number;
  name?: string;
  description?: string;
  code?: string;
  symbol?: string;
}

export interface SinglePaymentSupplier {
  id?: number;
  name: string;
  description?: string;
}

export interface StartSinglePaymentResponse {
  redirect_url?: string;
  init_point?: string;
  sandbox_init_point?: string;
}

function buildAuthHeaders(token: string) {
  return {
    Accept: 'application/json',
    Authorization: `Bearer ${token}`
  };
}

async function GetSinglePayment(token: string, id: string) {
  const response = await axios.get<SinglePayment>(
    `${process.env.REACT_APP_API_BACKEND}/single_payments/${id}`,
    {
      headers: buildAuthHeaders(token)
    }
  );
  return response.data;
}

async function GetPaymentSuppliers(token: string, id: string) {
  const response = await axios.get<SinglePaymentSupplier[]>(
    `${process.env.REACT_APP_API_BACKEND}/single_payments/${id}/suppliers`,
    {
      headers: buildAuthHeaders(token)
    }
  );
  return response.data;
}

async function StartPaymentProcess(token: string, id: string, paymentMethod: string) {
  const response = await axios.get<StartSinglePaymentResponse>(
    `${process.env.REACT_APP_API_BACKEND}/single_payments/${id}/start_payment/${paymentMethod}`,
    {
      headers: buildAuthHeaders(token)
    }
  );
  return response.data;
}

export const SinglePaymentsService = {
  GetSinglePayment,
  StartPaymentProcess,
  GetPaymentSuppliers
};
